import { render, staticRenderFns } from "./SettingLicense.vue?vue&type=template&id=86ed457e&scoped=true&"
import script from "./SettingLicense.vue?vue&type=script&lang=js&"
export * from "./SettingLicense.vue?vue&type=script&lang=js&"
import style0 from "./SettingLicense.vue?vue&type=style&index=0&id=86ed457e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ed457e",
  null
  
)

export default component.exports